/*
 * simple ABR Controller
 *  - compute next level based on last fragment bw heuristics
 *  - implement an abandon rules triggered if we have less than 2 frag buffered and if computed bw shows that we risk buffer stalling
 */

import Event from 'hls.js/src/events';
import EventHandler from 'hls.js/src/event-handler';
import { ErrorDetails } from 'hls.js/src/errors';
import { logger } from 'hls.js/src/utils/logger';

// import { max } from 'rxjs/operators';


const { performance } = window;

class AbrController extends EventHandler {
  constructor (hls) {
    console.log("ABR-V:1.1.0")
    super(hls, Event.FRAG_LOADING,
      Event.FRAG_LOADED,
      Event.FRAG_BUFFERED,
      Event.ERROR);
    this.lastLoadedFragLevel = 0;
    this._nextAutoLevel = -1;
    this.hls = hls;
    this.timer = null;
    this._bwEstimator = null;
    this.onCheck = this._abandonRulesCheck.bind(this);
    this.setBufferValues = new Set()
    this.setBitrate = new Set()
    this.setLevels = new Set()
    this.lastValue = 30 // hls.config.maxBufferLength
    this.minBufferValue = 30
    this.maxBufferValue = 0
    this.avgBuffer = 0
    this.pastBufferFactor = 10
    this.loading = false
    this.rebufferingRatio = 0.15
    this.playingTime = 0
    this.rebuffering = 0
    this.lastLevel
    this.lastMin = 0
    this.fraglastBuffered = 0
    this.checkFragLoad = 1
    this.init = 1
    this.lastDuration = 8.1
    this.avgBitrate = 0
    this.bufferTimer = null;
  }
  
  destroy () {
    this.clearTimer();
    EventHandler.prototype.destroy.call(this);
  }
  
  onFragLoading (data) {
    const frag = data.frag;
    // console.log("Loading")
    this.fraglastBuffered = Date.now()
    this.loading = true
    if (frag.type === 'main') {
      if (!this.timer) {
        this.fragCurrent = frag;
        this.timer = setInterval(this.onCheck, 100);
      }
    }
  }

  _abandonRulesCheck () {
    /*
      monitor fragment retrieval time...
      we compute expected time of arrival of the complete fragment.
      we compare it to expected time of buffer starvation
    */
    const hls = this.hls;
    const video = hls.media;
    const frag = this.fragCurrent;
    const checkInterval = 500;
    let lastPlayPos = 0;
    let currentPlayPos = 0;
    let bufferingDetected = false;
    if (!frag) {
      return;
    }

    const loader = frag.loader;
    const minAutoLevel = hls.minAutoLevel;

    // if loader has been destroyed or loading has been aborted, stop timer and return
    if (!loader || (loader.stats && loader.stats.aborted)) {
      logger.warn('frag loader destroy or aborted, disarm abandonRules');
      this.clearTimer();
      // _reset forced auto level value so that next level will be selected
      this._nextAutoLevel = -1;
      return;
    }
    const routine = () => {
      currentPlayPos = video.currentTime
      if (
        lastPlayPos > 0 &&
        !video.paused &&
        !bufferingDetected &&
        currentPlayPos <= lastPlayPos
      ) {
        this.rebuffering = this.rebuffering + 1
        bufferingDetected = true;
        // console.log("Buffering")
        if ((this.rebuffering /this.playingTime)> this.rebufferingRatio){
          // console.log("1")
          if (this.hls.currentLevel > 0) {
            // console.log("2")s
            this._reset()
            this.hls.nextAutoLevel = 0
            this.lastLoadedFragLevel = 0
            loader.abort()
            this.clearTimer() 
          }
          return
        }
        return;
      }
      // if (this.currentLevel == true) {
      //   this.hls.currentLevel = -1
      // }
      
      if (this.fraglastBuffered != 0 && Date.now() - this.fraglastBuffered > ((this.lastDuration*1000) + 1000) && this.loading != true){
        const bufferLength = this._getBufferLength(this.hls)
        if (bufferLength < (this.hls.config.maxBufferLength * 0.03) && this.hls.currentLevel != 0) {
          this._reset()
          loader.abort()
          this.hls.nextAutoLevel = 0
          // console.log("8")
          this.lastLoadedFragLevel = 0
          this.clearTimer()
          this.fraglastBuffered = Date.now()
          return
        }
        return;
      }
      
      if (
        lastPlayPos > 0 &&
        bufferingDetected &&
        !video.paused &&
        currentPlayPos > lastPlayPos
      ) {
        bufferingDetected = false;
      }
      lastPlayPos = currentPlayPos;
    }
  
    this.bufferTimer = window.setInterval(() => {
      if(!this.hls) {
        // console.info("Player Not defined")
      }
      if (this.loading == false) {
      let bufferlength = this._getBufferLength(this.hls)
      // console.log("BufferValue", bufferlength)
      this._getBufferValue(bufferlength)}
      this.playingTime = this.playingTime + 1
      this.playingTimeGlobal = this.playingTimeGlobal + 1
      // console.log("Playing Time, Rebuffering Time", this.playingTime, this.rebuffering)
      this._checkPlayingTime()
      routine()
    },1000)

    let stats = loader.stats;
    
    if (video && stats && ((!video.paused && (video.playbackRate !== 0)) || !video.readyState) && frag.autoLevel && frag.level) {
      let requestDelay = performance.now() - stats.trequest,
        playbackRate = Math.abs(video.playbackRate);
      // monitor fragment load progress after half of expected fragment duration,to stabilize bitrate
      if (requestDelay > (500 * frag.duration / playbackRate)) {
        let levels = hls.levels,
          loadRate = Math.max(1, stats.bw ? stats.bw / 8 : stats.loaded * 1000 / requestDelay), // byte/s; at least 1 byte/s to avoid division by zero
          // compute expected fragment length using frag duration and level bitrate. also ensure that expected len is gte than already loaded size
          level = levels[frag.level],
          levelBitrate = level.realBitrate ? Math.max(level.realBitrate, level.bitrate) : level.bitrate,
          expectedLen = stats.total ? stats.total : Math.max(stats.loaded, Math.round(frag.duration * levelBitrate / 8)),
          pos = video.currentTime,
          fragLoadedDelay = (expectedLen - stats.loaded) / loadRate
      
      }
    }
  }
  _getBufferLength (hls, index = 0) {
    if (!this.hls) {
      // console.info("Hls not defined")
      return 
    }
    if (index < hls.streamController.mediaBuffer.buffered.length) {
      if (
        hls.media.currentTime >=
          hls.streamController.mediaBuffer.buffered.start(index) &&
        hls.media.currentTime <=
          hls.streamController.mediaBuffer.buffered.end(index)
      ) {
        return (
          hls.streamController.mediaBuffer.buffered.end(index) -
          hls.media.currentTime
        );
      }
      return this._getBufferLength(hls, index + 1);
    }
    return undefined;
  };
  _getBufferValue (value)  {
    if (this.lastValue < value) {
      this.setBufferValues.add(this.minBufferValue)
      // console.log("min value", this.minBufferValue)
      this.maxBufferValue = value
      this.lastValue = value
      this.minBufferValue = value
      }
    
    if (value > this.maxBufferValue) {
        this.maxBufferValue = value
    }
    if (value < this.minBufferValue) {
        this.minBufferValue = value
        this.lastValue = this.minBufferValue
    }    
  }
  _getBestLevel () {
    const hls = this.hls
    var totalBuffer = 0
    var totalBitrate = 0
    var avgBuffer = 0
    var avgBitrate = 0
    var varianceBuffer = 0
    var varianceBitrate = 0
    var sdBuffer = 0
    var sdBitrate = 0
    var medianBuffer = 0

    if (this.init == 1 && this.setBufferValues.size == 4 && this.setBitrate.size >= 1 ||this.setBufferValues.size >= this.pastBufferFactor) {
      this.init = 2
      totalBuffer = Array.from(this.setBufferValues).reduce(function (a,b){
        return a+b;
      });
      avgBuffer = totalBuffer/this.setBufferValues.size
      function var_num(value) {
        return Math.pow(value - avgBuffer,2)
      }
      varianceBuffer = Array.from(this.setBufferValues).map(var_num)
      varianceBuffer = varianceBuffer.reduce(function(a,b){
        return a + b;
      });
      varianceBuffer = varianceBuffer / this.setBufferValues.size
      sdBuffer = Math.sqrt(varianceBuffer)
      totalBitrate = Array.from(this.setBitrate).reduce(function(a,b){
        return a + b;
      });
      avgBitrate = totalBitrate/this.setBitrate.size
      this.avgBitrate = avgBitrate
      varianceBitrate = Array.from(this.setBitrate).map((value) => { return Math.pow(value - avgBitrate, 2)})
      varianceBitrate = varianceBitrate.reduce(function(a,b){
        return a + b;
      })
      varianceBitrate = varianceBitrate / this.setBitrate.size
      sdBitrate = Math.sqrt(varianceBitrate)

      medianBuffer = Array.from(this.setBufferValues).sort()
      if (this.setBufferValues.size % 2 === 0) {
        medianBuffer = (medianBuffer[this.setBufferValues.size / 2 - 1] + medianBuffer[this.setBufferValues.size / 2]) / 2;
      } else {
        medianBuffer = medianBuffer[(this.setBufferValues.size - 1) / 2];
      }
      // console.log("MedianBuffer",medianBuffer,avgBuffer - medianBuffer)
      if (avgBuffer > ((1*this.hls.config.maxBufferLength)/100) && avgBuffer <= (10*this.hls.config.maxBufferLength)/100
          && this.hls.levels[this.hls.currentLevel].bitrate >= this.hls.levels[0].bitrate) {
          // console.log("Move to smallest quality")
          // this.player.loadLevel = 0
          this._reset()
          return 0 // assuming that the levels are sorted in the ascending order, find another way. 
      } 
      if ((avgBuffer > (10*this.hls.config.maxBufferLength)/100) && (avgBuffer <= ((20*this.hls.config.maxBufferLength)/100))){
          // console.log("Stay in the current quality")
          this._reset()
          // console.log("level returned 1",this.lastLoadedFragLevel)
          return this.lastLoadedFragLevel //@todo most probably breaking from here. specify other ways to maintain last loaded fragment.
      }
      if (avgBuffer > ((20*this.hls.config.maxBufferLength)/100) && (avgBuffer <= ((70*this.hls.config.maxBufferLength)/100))
      //@todo find the media, value of the class
          && (this.hls.levels[this.hls.currentLevel].bitrate < avgBitrate)){
            const classMedian = (((20*this.hls.config.maxBufferLength/100)+ (70*this.hls.config.maxBufferLength/100)) / 2)
            let level = this.hls.currentLevel
            if ((this.avgBuffer < classMedian && avgBuffer - medianBuffer <= -1.5) || sdBuffer > 5 ) {
              this._reset()
              return this.lastLoadedFragLevel
            } else if ((this.avgBuffer < classMedian && avgBuffer - medianBuffer > -1.5 && this.lastLoadedFragLevel < this.hls.levels.length -1) ||
             (sdBuffer >= 5 && avgBuffer - medianBuffer >= 3)) {
              this._reset()
              this.lastLoadedFragLevel = (this.lastLoadedFragLevel == 0) ? this.lastLoadedFragLevel + 1: this._findNextBestLevel(sdBuffer)
              return this.lastLoadedFragLevel
            } else {
              const level = this._findNextBestLevel(sdBuffer)
              this._reset()
              this.lastLoadedFragLevel = level
              return level
            }
          }

      if ((avgBuffer > ((70*this.hls.config.maxBufferLength)/100)) && (this.hls.levels[this.hls.currentLevel].bitrate < avgBitrate * 0.8 )) {
        // console.log("AvgBuffer more than 70%")
        const level = this._findNextBestLevel(sdBuffer)
        return level
        }else {
        this._reset()
        return this.lastLoadedFragLevel;
      }
      } else {
      if (this.lastLevel != undefined && this.lastLevel != this.hls.currentLevel){
        return this.lastLoadedFragLevel
      } else {
        return this.lastLoadedFragLevel
      }
      }
  }
  _findNextBestLevel(sd) {
    for (var i = 0; i< this.hls.levels.length; i++) {
      if  (i < this.hls.levels.length -2 && ((this.avgBitrate * 0.8) >= this.hls.levels[i].bitrate) && (this.avgBitrate) <= this.hls.levels[i+1].bitrate) {
        this._reset()
        this.lastLoadedFragLevel = (sd< 5) ? i : i-1
        return level
        } else if (i == this.hls.levels.length - 1) {
        const buffer = this._getBufferLength(this.hls)
        this.lastLoadedFragLevel = (buffer > this.lastDuration * 1.5 && sd < 5) ? i : i-1
        this._reset()
        return this.lastLoadedFragLevel 
      }
    }
  }
  _reset () {
    this.avgBitrate = 0
    this.avgBuffer = 0
    this.setBufferValues.clear()
    // console.log("SetBufferValueSize", this.setBufferValues.size)
    this.setBitrate.clear()
    // console.log("SetBitrateSize", this.setBitrate.size)
  }

  _checkPlayingTime () {
    if (this.playingTime > 60) {
      this.playingTime = 0
      this.rebuffering = 0
    }
  }

  onFragLoaded (data) {
    const frag = data.frag;
    this.checkFragLoad = 1
    this.loading = false
    // console.log("loaded")
    if (frag.type === 'main' && Number.isFinite(frag.sn)) {
      // stop monitoring bw once frag loaded
      this.clearTimer();
      // store level id after successful fragment load
      this.lastLoadedFragLevel = frag.level;
      // _reset forced auto level value so that next level will be selected
      this._nextAutoLevel = -1;
      // const level = this.hls.levels[frag.level];
      const bitrate = data.stats.bw
      this.lastDuration = (data.frag.duration)
      // console.log("levelLoadedDuration", data.frag.duration)
      if(bitrate != undefined) {
        this.setBitrate.add(bitrate)
      }
     
    }
  }
  
 
  onFragBuffered (data) {
    const stats = data.stats;
    const frag = data.frag;

    if (stats.aborted !== true && frag.type === 'main' && Number.isFinite(frag.sn) && ((!frag.bitrateTest || stats.tload === stats.tbuffered))) {
      let fragLoadingProcessingMs = stats.tparsed - stats.trequest;
    }

  }

  onError (data) {
    // stop timer in case of frag loading error
    switch (data.details) {
    case ErrorDetails.FRAG_LOAD_ERROR:
    case ErrorDetails.FRAG_LOAD_TIMEOUT:
      this.clearTimer();
      break;
    default:
      break;
    }
  }

  clearTimer () {
    clearInterval(this.timer);
    this.timer = null;
  }
  // return next auto level
  get nextAutoLevel () {
    // console.log("Getting Auto Level")
    
    let nextABRAutoLevel = this._nextABRAutoLevel;
    return nextABRAutoLevel
  }
  get _nextABRAutoLevel () {
    // console.log("next abr auto level")
    let hls = this.hls, maxAutoLevel = hls.maxAutoLevel, levels = hls.levels, config = hls.config, minAutoLevel = hls.minAutoLevel;
    // console.log("rebuffering ratio",(this.rebuffering/this.playingTime), this.rebufferingRatio)
    if ((this.rebuffering/this.playingTime)>this.rebufferingRatio){
      if (this.hls.currentLevel == 0) {
        return 0
      } else {
        let bestLevel = 0 
        this.lastLevel = bestLevel
        return 0
      }
    } else {
      let bestLevel = this._getBestLevel()
      this.lastLevel = bestLevel
      // console.log("level Selected",bestLevel)
      return bestLevel
    }
  }

  set nextAutoLevel (nextLevel) {
    this._nextAutoLevel = nextLevel;
  }
}

export default AbrController ;



// WEBPACK FOOTER //
// ./src/js/hlsjs/abr-controller.js